export const defaultQueryProps = {
  refetchOnWindowFocus: false,
};
